export enum Type {
  Administrator,
  Bank,
  Client,
  BusinessUnit,
  PortfolioManager
}

export const TYPES: Type[] = Object.values(Type)
  .filter(i => typeof i === 'number')
  .map(i => i as Type)

export interface Organisation {
  name: string
  parent: string | null
  slug: string
  type: Type
}

export const ABSA = {
  name: 'Absa',
  parent: null,
  slug: 'Absa',
  type: Type.Bank
}

export function parseType(orgTypeString: string): Type {
  switch (orgTypeString) {
    case 'Administrator':
      return Type.Administrator
    case 'Bank':
      return Type.Bank
    case 'Client':
      return Type.Client
    case 'BusinessUnit':
      return Type.BusinessUnit
    case 'PortfolioManager':
      return Type.PortfolioManager
  }
}

export function parseTypeSlug(orgTypeString: string): Type {
  switch (orgTypeString) {
    case 'bank':
      return Type.Bank
    case 'client':
      return Type.Client
    case 'business_unit':
      return Type.BusinessUnit
    case 'portfolio_manager':
      return Type.PortfolioManager
  }
}

export function typeCssClass(orgType: Type): string {
  switch (orgType) {
    case Type.Bank:
      return 'bank'
    case Type.BusinessUnit:
      return 'business-unit'
    case Type.Client:
      return 'client'
    case Type.PortfolioManager:
      return 'portfolio-manager'
  }
}

export function typeString(orgType: Type): string {
  switch (orgType) {
    case Type.Bank:
      return 'bank'
    case Type.BusinessUnit:
      return 'business_unit'
    case Type.Client:
      return 'client'
    case Type.PortfolioManager:
      return 'portfolio_manager'
  }
}

export function typeSlug(orgType: Type): string {
  switch (orgType) {
    case Type.Bank:
      return 'bank'
    case Type.BusinessUnit:
      return 'business-unit'
    case Type.Client:
      return 'client'
    case Type.PortfolioManager:
      return 'portfolio-manager'
  }
}

export enum Case {
  LowerCase,
  TitleCase
}

type LabelOptions = {
  case?: Case
  plural?: boolean
}

export function typeLabel(orgType: Type, options?: LabelOptions): string {
  let value = ''

  const defaultOptions = { case: Case.TitleCase, plural: false }

  const allOptions = {
    ...defaultOptions,
    ...options
  }

  const { plural } = allOptions

  switch (orgType) {
    case Type.Bank:
      value = plural ? 'Banks' : 'Bank'
      break
    case Type.BusinessUnit:
      value = plural ? 'Business Units' : 'Business Unit'
      break
    case Type.Client:
      value = plural ? 'Clients' : 'Client'
      break
    case Type.PortfolioManager:
      value = plural ? 'Portfolio Managers' : 'Portfolio Manager'
      break
  }

  switch (options.case) {
    case Case.LowerCase:
      value = value.toLowerCase()
  }

  return value
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseOrganisation(org: any): Organisation {
  return {
    name: org.name,
    parent: org.parent,
    slug: org.slug,
    type: parseType(org.type)
  }
}
